import React, { useState, useEffect } from "react";
import {
  Space,
  Table,
  Tag,
  Form,
  theme,
  Select,
  Row,
  Button,
  Col,
  Input,
  DatePicker,
  Rate,
  message,
} from "antd";
import axios from "axios";
import moment from "moment/moment";
import AddBtn from "./add";
import BatchDelete from "./batchDelete";
import localhost from "../../constants/localhost";
import FileOverview from "./fileOverview";
import { exportFn } from "../../utils/exportUtil";

const mockData = Array(10)
  .fill(null)
  .map((_, index) => {
    return {
      id: index + 1,
      title: "捷途山海L9功能手册",
      classification: "达人分享",
      userLevel: "KOL达人",
      carModel: "山海系列",
      tagecontentTypess: "使用攻略",
      content:
        "捷途山海L9，是捷途汽车全新打造的新能源序列首款产品，产品定位“大家庭大七座超混SUV”，搭载奇瑞鲲鹏超能混动C-DM技术，主打空间大、油耗省、动力强的产品优势，覆盖家庭旅行混动出行的使用场景。",
      file: "",
      starLevel: index,
      allowDownload: index / 2 ? "是" : "否",
      deliveryChannel: index / 2 ? "公域" : "私域",
      flow: 1000,
      createDate: "2025-5-26 13:20:44",
    };
  });

const El = () => {
  const { token } = theme.useToken();
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [pageInfo, setPageInfo] = useState({ pageNo: 1, pageSize: 10 });
  const [dataInfo, setDataInfo] = useState({ total: 20, dataSource: mockData });
  const [loading, setLoading] = useState(false);

  const getData = () => {
    setLoading(true);
    const formData = form.getFieldsValue();
    if (formData.time) {
      formData.createDateStart = moment(formData.time[0]).format("YYYY-MM-DD");
      formData.createDateEnd = moment(formData.time[1]).format("YYYY-MM-DD");
      formData.time = undefined;
    }
    axios
      .post(`${localhost}/manage/material/queryList`, {
        pageNo: 1,
        pageSize: 20,
        ...formData,
        recycleFlag: 0,
      })
      .then((res) => {
        setDataInfo({
          total: res?.data?.total || 0,
          dataSource: res?.data?.list || [],
        });
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const pagination = {
    showTotal: (total, range) => {
      return `当前第 ${range[0]} 到 ${range[1]} 条，总共${total}条数据`;
    },
    total: dataInfo.total,
    current: pageInfo.pageNo,
    pageSize: pageInfo.pageSize,
    onChange: (page, pageSize) => {
      setPageInfo({ pageNo: page, pageSize: pageSize }, () => {
        getData();
      });
    },
    onShowSizeChange: (current, size) => {
      setPageInfo({ pageNo: current, pageSize: size }, () => {
        getData();
      });
    },
  };

  useEffect(() => {
    getData();
  }, []);

  const onSearch = () => {
    setPageInfo({ pageNo: 1, pageSize: 10 });
  };

  const onReset = () => {
    form.resetFields();
    setPageInfo({ pageNo: 1, pageSize: 10 });
  };

  const onDelete = ({ id }) => {
    axios
      .get(`${localhost}/manage/material/delete?id=${id}`)
      .then((res) => {
        message.success("删除成功！");
        setPageInfo({ ...pageInfo, pageNo: 1 });
        getData();
      })
      .catch((error) => {
        message.error("网络异常，请重试！");
        setLoading(false);
      });
  };

  const columns = [
    {
      title: "标题",
      dataIndex: "title",
      fixed: "left",
      key: "title",
      minWidth: 120,
      render: (text) => <a>{text}</a>,
    },
    {
      title: "所属分类",
      dataIndex: "classification",
      key: "classification",
      minWidth: 150,
      render: (val) => <Tag color="magenta">{val}</Tag>,
    },
    {
      title: "用户分层",
      dataIndex: "userLevel",
      key: "userLevel",
      minWidth: 120,
      render: (val) => <Tag color="orange">{val}</Tag>,
    },
    {
      title: "车型解析",
      dataIndex: "carModel",
      key: "carModel",
      minWidth: 120,
      render: (val) => <Tag color="green">{val}</Tag>,
    },
    {
      title: "内容场景",
      dataIndex: "tagecontentTypess",
      key: "contentType",
      minWidth: 120,
      render: (val) => <Tag color="purple">{val}</Tag>,
    },
    {
      title: "内容",
      dataIndex: "content",
      key: "content",
      minWidth: 120,
      render: (val) => {
        return (
          <div
            title={val}
            style={{
              maxWidth: 300,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {val}
          </div>
        );
      },
    },
    {
      title: "附件",
      dataIndex: "file",
      key: "file",
      minWidth: 100,
      render: () => <FileOverview />,
    },

    {
      title: "星级",
      dataIndex: "starLevel",
      key: "starLevel",
      minWidth: 120,
      render: (val) => <Rate disabled defaultValue={val} />,
    },

    {
      title: "是否允许下载",
      dataIndex: "allowDownload",
      key: "allowDownload",
      minWidth: 160,
      render: (val) => (val ? "是" : "否"),
    },
    {
      title: "投放渠道",
      dataIndex: "deliveryChannel",
      key: "chandeliveryChannelnel",
      minWidth: 120,
      render: (val) => (
        <Tag bordered={false} color="lime">
          {val}
        </Tag>
      ),
    },

    {
      title: "流量",
      dataIndex: "flow",
      key: "flow",
      minWidth: 120,
    },
    {
      title: "创建时间",
      dataIndex: "createDate",
      key: "createDate",
      minWidth: 120,
    },
    {
      title: "操作",
      dataIndex: "action",
      key: "action",
      fixed: "right",
      unexport: true,
      minWidth: 120,
      render: (_, record) => (
        <Space size="middle">
          <AddBtn id={record.id} mode="detail" />
          <AddBtn id={record.id} mode="edit" getData={getData} />
          <a onClick={() => onDelete({ id: record.id })}>删除</a>
          <a onClick={() => onDownload([record])}>下载</a>
        </Space>
      ),
    },
  ];

  const onDownload = (data) => {
    console.log("下载");
    exportFn(data, columns);
  };

  const formStyle = {
    maxWidth: "none",
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    padding: 24,
  };

  return (
    <div>
      <div>
        <Form form={form} name="advanced_search" style={formStyle}>
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item name="title" label="标题">
                <Input placeholder="请输入标题" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="classification" label="所属分类">
                <Select placeholder="请选择所属分类" allowClear>
                  <Select.Option value="知识科普">知识科普</Select.Option>
                  <Select.Option value="活动邀请">活动邀请</Select.Option>
                  <Select.Option value="达人分享">达人分享</Select.Option>
                  <Select.Option value="操作指南">操作指南</Select.Option>
                  <Select.Option value="问题锦囊">问题锦囊</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="userLevel" label="用户分层">
                <Select placeholder="请选择用户分层" allowClear>
                  <Select.Option value="普通用户">普通用户</Select.Option>
                  <Select.Option value="车主用户">车主用户</Select.Option>
                  <Select.Option value="官方账号">官方账号</Select.Option>
                  <Select.Option value="KOL达人">KOL达人</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="contentType" label="内容场景">
                <Select placeholder="请选择内容场景" allowClear>
                  <Select.Option value="旅行者分享">旅行者分享</Select.Option>
                  <Select.Option value="使用攻略">使用攻略</Select.Option>
                  <Select.Option value="活动分享">活动分享</Select.Option>
                  <Select.Option value="爱车养车">爱车养车</Select.Option>
                </Select>
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item name="time" label="创建时间">
                <DatePicker.RangePicker showTime />
              </Form.Item>
            </Col>
            <Col span={8}>
              <div style={{ textAlign: "right" }}>
                <Space size="small">
                  <Button type="primary" onClick={onSearch}>
                    搜索
                  </Button>
                  <Button onClick={onReset}>重置</Button>
                </Space>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          margin: "16px 0px",
        }}
      >
        <Space>
          <AddBtn getData={getData} />
          <BatchDelete
            selectedRowKeys={selectedRowKeys}
            batchRecycleCb={() => {
              setPageInfo({ ...pageInfo, pageNo: 1 });
              getData();
            }}
          />
          <Button
            onClick={() =>
              onDownload(
                selectedRows.length ? selectedRows : dataInfo.dataSource
              )
            }
          >
            导出
          </Button>
        </Space>
      </div>
      <div>
        <Table
          rowKey="id"
          columns={columns}
          rowSelection={{
            selectedRowKeys,
            onChange: (keys, selectedRows) => {
              console.log("selectedRowKeys changed: ", keys);
              setSelectedRowKeys(keys);
              setSelectedRows(selectedRows);
            },
          }}
          scroll={{ x: "max-content", y: "calc(100vh - 240px - 55px - 64px)" }}
          style={{
            height: "calc(100vh - 240px)",
            overflowY: "scroll",
          }}
          // loading={loading}
          dataSource={dataInfo.dataSource}
          pagination={pagination}
        />
      </div>
    </div>
  );
};

export default El;
